import MinimalRestApiBanner from "../../assets/minimal-rest-api.png";
import FunctionAppBanner from "../../assets/function-app.png";
import CleanArchitectureBanner from "../../assets/clean-architecture.png";
import MicroservicesBanner from "../../assets/microservices.png";
import StorageQueueBanner from "../../assets/storage-queue.png";
import RestApiBanner from "../../assets/rest-api.png";
import CiCdBanner from "../../assets/ci-cd.png";

export const projectsData = [
  {
    id: 1,
    image: MinimalRestApiBanner,
    title: "Minimal API using .NET 7",
    category: "Development",
    url: "#",
  },
  {
    id: 2,
    image: FunctionAppBanner,
    title: "Azure function && .NET 6",
    category: "Cloud",
    url: "#",
  },
  {
    id: 3,
    image: CleanArchitectureBanner,
    title: "Clean architecture using .NET 6",
    category: "Architecturing",
    url: "https://github.com/bmassioui/CleanArchitecture",
  },
  {
    id: 4,
    image: MicroservicesBanner,
    title: "Microservices using .NET 6",
    category: "Architecturing",
    url: "https://github.com/uit-ac-ma/dotnet5-microservices",
  },
  {
    id: 5,
    image: StorageQueueBanner,
    title: "Azure storage queue && .NET 6",
    category: "Cloud",
    url: "#",
  },
  {
    id: 6,
    image: RestApiBanner,
    title: "Secure .NET 6 REST API with JWT",
    category: "Development",
    url: "#",
  },
  {
    id: 7,
    image: CiCdBanner,
    title: "Github action CI/CD for .NET 6 REST API",
    category: "DevOps",
    url: "#",
  },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "Development",
  },
  {
    name: "Cloud",
  },
  {
    name: "DevOps",
  },
  {
    name: "Architecturing",
  },
];
